import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  MarkerClusterer,
  Autocomplete,
  DirectionsRenderer,
} from '@react-google-maps/api'
import { useRef, useState, useEffect } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import delivered from "../../images/deliverd.jpg";
import { Dropdown } from "react-bootstrap";
import { Row, Col, Card, Accordion } from "react-bootstrap";
import Switch from "react-switch";
// var loadjs = require('loadjs');
const MyLocation = () => {
  const [map, setMap] = useState(/** @type google.maps.Map */(null))
  const [directionsResponse, setDirectionsResponse] = useState(null)
  const [distance, setDistance] = useState('')
  const [duration, setDuration] = useState('')
  const [lat, setLat] = useState(0.0000);
  const [lng, setLng] = useState(0.0000);
  const [startLat, setStartLat] = useState(0.0000);
  const [startLng, setStartLng] = useState(0.0000);
  const [zoom, setZoom] = useState(8);
  const [activeDefault, setActiveDefault] = useState(0);
  const [darkMode, setDarkMode] = useState(false);
  const [preDarkMode, setPreDarkMode] = useState(false);
  const [destLat, setDestLat] = useState(40.7137919238253); //live
  const [destLng, setDestLng] = useState(-74.01501527384697); //live

  // const [destLat, setDestLat] = useState(23.024826812533117); //local
  // const [destLng, setDestLng] = useState(72.50694258151395); //local


  const darkModeStyle = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ]
  useEffect(() => {
    document.title = "Track My Gear"
    if ("geolocation" in navigator) {
      navigator.geolocation.watchPosition(position => {
        setLat(position.coords.latitude)
        setLng(position.coords.longitude)

        if (startLat == 0.0000 && startLng == 0.0000) {
          setStartLat(position.coords.latitude)
          setStartLng(position.coords.longitude)
        }
        // calculateRoute()
        // console.log("new location updated successfully");
        // console.log(position)
      })
    } else {
      console.log("Sorry, geolocation is not available on your device. You need that to use this app");
    }

    // loadjs('https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js', function() {
    //   setCheck(true)
    // })
   
    // const script = document.createElement('script');
    // script.src = "https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js";
    // script.async = true;
    // document.body.appendChild(script);
    // return () => {
    //   document.body.removeChild(script);
    // }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      // loadjs('https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js', function() {
      // })
        const script = document.createElement('script');
        script.src = "https://static.cdn-apple.com/businesschat/start-chat-button/2/index.js";
        script.async = true;
        document.body.appendChild(script);
        // setDarkMode(true)
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    calculateRoute()
  }, [lat, lng]);

  const defaultAccordion = [
    {
      title: "When will by delivery arrive?",
      text:
        "Please see the update arrival time above. Weather, traffic patterns and unforeseen circumstances may incur a slight delay.",
      bg: "info",
    },
    {
      title: "Do I have to be at the location for delivery or pickup? ",
      text:
        "No you do not. We will deliver the items to a safe location and if we are picking up please leave the items in a safe location so the driver may retrieve it.",

      bg: "info",
    },
    {
      title: "Can I change the location of my delivery?",
      text:
        "Since the items are on its way, you cannot change the location. More questions? Call 844-795-1539 between 9am-5pm EST.",

      bg: "info",
    },
    {
      title: "How do I prepare the items for return? ",
      text:
        "Please make sure any items delivered in a box is back in the box and any crib mattresses are back in its packaging.",

      bg: "info",
    },
  ];

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAJ-YSuDVosXBWVTQAAb7MbLpyjpMoHaC0",
    // libraries: ['places'],
  })



  // const destiantionRef = useRef()

  if (!isLoaded) {
    return <div
      style={{
        textAlign: "center",
        width: "100%",
        position: "absolute",
        marginBottom: "10px",
      }}
    >
      <Spinner animation="border" role="status">
        <span className="visually-hidden"></span>
      </Spinner>
    </div>
  }

  // const getLocation = () => {
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.watchPosition(position => {
  //         setLat(position.coords.latitude)
  //         setLng(position.coords.longitude)
  //         calculateRoute()
  //         console.log("new location updated successfully");
  //         console.log(position)
  //         // console.log('lat', position.coords.latitude)
  //         // console.log('lng', position.coords.longitude)
  //       //   alert("new location updated successfully");
  //     })
  //  } else {
  //     alert("Sorry, geolocation is not available on your device. You need that to use this app");
  //   }
  // }

  // getLocation();

  async function calculateRoute() {
    // console.log("testttttttttttttttttttttttttttttttttttttt")
    if (lat == '' || lng == '') {
      return
    }

    const places = [{ "latitude": parseFloat(lat), "longitude": parseFloat(lng) }, { "latitude": parseFloat(destLat), "longitude": parseFloat(destLng) }]

    const waypoints = places.map(p => ({
      location: { lat: p.latitude, lng: p.longitude },
      stopover: true
    }))
    const origin = waypoints.shift().location;
    const destination = waypoints.pop().location;

    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService()
    const results = await directionsService.route({
      origin: origin,
      destination: destination,
      // eslint-disable-next-line no-undef
      //   waypoints: waypoints,
      travelMode: 'DRIVING',
      drivingOptions: {
        departureTime : new Date(),
        trafficModel : "bestguess"
      }
    })
    // showSteps(results)
    // console.log("testttttttttttttttttttttttttttttttttttttt", results)
    // setDarkMode(preDarkMode)
    setDirectionsResponse(results)
    setDistance(results.routes[0].legs[0].distance.text)
    setDuration(results.routes[0].legs[0].duration_in_traffic ? results.routes[0].legs[0].duration_in_traffic.text : results.routes[0].legs[0].duration.text)
    // console.log("testinggggggggggggg distance", results.routes[0].legs[0].distance.text)
    // console.log("testinggggggggggggg speed", results.routes[0].legs[0].duration.text)
  }

  function showSteps(directionResult) {
     var myRoute = directionResult.routes[0].legs[0];
     for (var i = 0; i < myRoute.steps.length; i++) {
      //  console.log("5555555555555555555", myRoute.steps[i])
     }
    }

  const reloadPage = () => {
    window.location.reload();
  }

    // async function showSteps(directionResult) {
  //   var myRoute = directionResult.routes[0].legs[0];
  //  //  for (var i = 0; i < myRoute.steps.length; i++) {
  //    //  console.log("5555555555555555555", myRoute.steps[i].end_point)
  //    //  console.log("5555555555555555555", myRoute.steps[i].start_point)
  //     if(myRoute.steps.length > 0){
  //      var marker = await new window.google.maps.Marker({
  //          position: myRoute.steps[0].start_point,
  //          map: map,
  //          icon: "https://api.babiesgetaway.com/upload/1654089520703-bgimg.png"
  //        })

  //        var marker2 = await new window.google.maps.Marker({
  //          position: myRoute.steps[myRoute.steps.length - 1].end_point,
  //          map: map,
  //          icon: "https://api.babiesgetaway.com/upload/1654202610577-home (1).png"
  //        })
  //    }
  //  }

  //   function clearRoute() {
  //     setDirectionsResponse(null)
  //     setDistance('')
  //     setDuration('')
  //     // originRef.current.value = ''
  //     // destiantionRef.current.value = ''
  //   }

  //     setTimeout(() => {
  //     setLat("21.643788389040644")
  //     setLng("69.60619483867826")
  //     calculateRoute()

  //   }, 5000);
  const handleChange = () => {
    setDarkMode(!darkMode)
    calculateRoute()
  }

  return (
    <div style={{overflowX: "hidden"}}>
      <div className="staticBar" style={{ backgroundColor: "#3D455A", width: '100%', height: "3rem", borderBottom : "1px solid white"}}>
        <a href="https://trackmygear.babiesgetaway.com">
          <img style={{width: '100px'}} src="https://www.babiesgetaway.com/public/img/logo_web_white.png" alt="Babies Getaway"/>
        </a>
        <label style={{marginBottom : "0px", marginTop : "5px"}}>
        <span className='darkModeFont'>Dark Mode</span>
        <div style={{verticalAlign : "middle", display : "inline-block"}}>
        <Switch onChange={handleChange} checked={darkMode} />
        </div>
      </label>
      </div>
      <div style={{ backgroundColor: "#3D455A"}}>
        <div className="arrows">
          <div className="arrow step1">
            <span>Delivery in Progress</span>
          </div>
          <div style={{backgroundColor : "#FE634E"}} className="arrow step2">
            <span>Delivery Completed</span>
          </div>
          {/* <div class="arrow step3">
            <span>3. Listen</span>
          </div> */}
        </div>
        </div>
      <div style={{ width: '100%', height: '65vh',/* marginTop: "3rem",*/ overflowX: "hidden" }}>
        <GoogleMap
          // center={center}
          center={{ lat: parseFloat(startLat), lng: parseFloat(startLng) }}
          zoom={zoom}
          mapContainerStyle={{ width: '100%', height: '100%' }}
          options={{
            zoomControl: true,
            gestureHandling: 'cooperative',
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            // keyboardShortcuts:false,
            styles: darkMode ? darkModeStyle : [],
          }}
          onLoad={(map) => {
            setMap(map)
            calculateRoute()
          }}
          onZoomChanged={() => map ? setZoom(map.getZoom()) : ""}
        >
          <Marker
            // icon={"https://api.babiesgetaway.com/upload/1654089520703-bgimg.png"}
            label={{
              text: "\ue558",
              fontFamily: "Material Icons",
              color: "#ffffff",
              fontSize: "20px"
            }}
            title= "Starting"
            position={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
          />
          <Marker
            // icon={"https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|FE634E"}
            //   icon= {{
            //     // path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            //     fillColor: "black",
            //     fillOpacity : "1"
            //     // scale: 3
            // }}
            label={{
              text: "\ue88a",
              fontFamily: "Material Icons",
              color: "#ffffff",
              fontSize: "20px",
            }}
            title= "Destination"
            position={{ lat: parseFloat(destLat), lng: parseFloat(destLng) }}
          />
          {directionsResponse && (
            <DirectionsRenderer directions={directionsResponse}
              options={{
                preserveViewport: true,
                suppressMarkers: true,
                polylineOptions: {
                  // strokeOpacity: 4,
                  strokeColor: darkMode ? '#FE634E' :'#3D455A',
                  strokeWeight: 6
              },
              }} />
          )}
        </GoogleMap>
      </div>
      <div className='realtime-map-update'>
        <div style={{position: 'absolute', right: '30px', zIndex: 1}}>
          REAL TIME UPDATES OFF
          {/* <Spinner className='loading-map' animation="grow" />
          <Spinner className='loading-map' animation="grow" />
          <Spinner className='loading-map' animation="grow" /> */}
          <br /><span>Pickup Window: 9-11am</span>
          {/* <br /><span style={{color : "#FE634E"}}>ETA : <span style={{textDecoration : "underline"}}>{duration}</span></span> */}
        </div>
      </div>
      <Row style={{ top: "7rem", margin: '0px' }}>
        <Col xl="12" style={{padding: '0px'}}>
          <Card className='map-detail-card'>
            <Row>
              <Col xl="6">
                <Card.Header className="d-block card-header" style={{padding : "1.5rem 1.875rem 1.25rem"}}>
                  <div className="profile-uoloaded-post border-bottom-1">
                    <div className="media pt-3 pb-3">
                      <Col style={{ flexGrow: "0" }}>
                        <img
                          src="https://www.babiesgetaway.com/public/img/profile_pictures/no-image.png"
                          alt=""
                          className="mr-3 rounded"
                          width={100}
                        />
                        <span className="star-review d-inline-block mb-2 fs-16 wspace-no">
                          <i className="fa fa-star fs-16 text-orange"></i>{" "}
                          <i className="fa fa-star fs-16 text-orange"></i>{" "}
                          <i className="fa fa-star fs-16 text-orange"></i>{" "}
                          <i className="fa fa-star fs-16 text-orange"></i>{" "}
                          <i className="fa fa-star fs-16 text-orange"></i>{" (45)"}
                          {/* <i className="fa fa-star fs-16 text-gray"></i>{" 45"} */}
                        </span>
                      </Col>
                      <div className="media-body" style={{ overflow: "auto", marginTop: "10px" }}>
                        <h5 className="m-b-5" style={{ fontWeight: "600", color: "white" }}>
                          {"John Doe"}
                        </h5>
                        <span className='span-map'>{"Babies Getaway U.S"}</span>
                        <a style={{cursor : "pointer", width : "fit-content", color: "white"}} href={'tel:+1844-795-1539'}>{"844-795-1539"}</a>
                        <span className='span-map'>{"2020 Nissan NV 200"}</span>
                        {/* <p className="mb-0">{item.message}</p> */}
                      </div>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="card-body" style={{padding : "1.875rem"}}>
                  <div style={{ paddingLeft: "15px" }} >
                    <Row>
                    <Col xl="6">
                    <div style={{width: "fit-content"}}> 
                      <a className="btn btn-secondary" href="" style={{ backgroundColor: "#FE634E", borderColor: "#FE634E", pointerEvents: "none", cursor: "default" }}>
                          {"Delivery Completed"}
                      </a>
                      <p style={{textAlign : "center"}}>Today at 9:29 AM</p>
                    </div>
                    <span style={{ paddingTop: "10px" }}><strong>Notes</strong> :</span>
                    <p>Walk up driverway to side door</p>
                    {/* <Row> */}
                    {/* <Col xm="6"> */}
                    <p><strong> Destination</strong> : New York, NY 10281 </p>
                    <span><strong> Items & Qty</strong> :</span>
                    <p> (1) Full Size Mattress & Linen</p>
                    {/* <p>New York, NY 10281</p> */}
                    {/* </Col> */}
                    {/* <Col xm="6">
                        <span>Pickup Contact</span>
                        <p>test 123</p>
                        <p>test 123</p>
                          </Col> */}
                    {/* </Row> */}
                    </Col>
                    <Col xl="6">
                      <img src={delivered} style={{height : "100%", width : "100%", borderRadius : "1.25rem"}}/>
                      </Col>
                      </Row>

                  </div>
                </Card.Body>
                <hr style={{ borderTop: "1px solid white" }}></hr>
              </Col>
              <Col xl="6">
                <Card.Header className="d-block card-header" style={{padding : "1.5rem 1.875rem 1.25rem"}}>
                  <Card.Title style={{ color: "white" }}>FAQ's</Card.Title>
                </Card.Header>
                <Card.Body className="card-body" style={{padding : "1.875rem"}}>
                  <Accordion
                    className="accordion accordion-primary"
                    defaultActiveKey="0"
                  >
                    {defaultAccordion.map((d, i) => (
                      <div className="accordion__item" key={i}>
                        <Accordion.Toggle
                          as={Card.Text}
                          eventKey={`${i}`}
                          className={`accordion__header rounded-lg ${activeDefault === i ? "" : "collapsed"
                            }`}
                          onClick={() =>
                            setActiveDefault(activeDefault === i ? -1 : i)
                          }
                        >
                          <span className="accordion__header--text">{d.title}</span>
                          <span className="accordion__header--indicator"></span>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={`${i}`}>
                          <div className="accordion__body--text">{d.text}</div>
                        </Accordion.Collapse>
                      </div>
                    ))}
                  </Accordion>      
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Col>
        <div
          style={{ width: "100%" }}
          className="apple-business-chat-banner-container"
          data-apple-business-id="313f0823-354f-45e2-b03d-5dab99d5608e"
          data-apple-business-phone="844-795-1539"
          data-apple-banner-cta="CONTACT A BABY GEAR GURU"
          data-apple-banner-context="Chat with us about renting baby gear or an existing rental."
          data-apple-banner-rounded-corners="true"
          data-apple-banner-scale="1.3"
          data-apple-banner-background-color="#3D455A"
          data-apple-banner-text-color="#ffffff"
          data-apple-banner-icon-background-color="#ffffff"
          data-apple-banner-icon-color="#3D455A"
          data-apple-banner-orientation="vertical"
          data-apple-icon-scale="1"
          data-apple-icon-title="CONTACT A BABY GEAR GURU">
        </div> 
      </Row>
    </div>
  )
}

export default MyLocation;